import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { DecimalPipe, CurrencyPipe, formatDate } from '@angular/common';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { SharingService } from '../../../shared/shared.service';
import { SaveFormDeclaration } from '../../models/SaveFormDeclaration';
import { Activity1, Activity2, Activity3, Activity4, Activity5 } from '../../models/Activities';
import { DeclarationService } from '../../services/forms.service';
import { from } from 'rxjs';
import { SaveFormDeclarationLocalData } from '../../../dashboard/saveDeclarationdata';
import { CustomSpinnerComponent } from '../../../../shared/components/custom-spinner/custom-spinner.component';
import { NumberFormatPipe } from 'src/app/shared/number.pipe';

@Component({
  selector: 'app-form4',
  templateUrl: './form4.component.html',
  styleUrls: ['./form4.component.css']
})
export class Form4Component implements OnInit {
  customSpinnerComponent = CustomSpinnerComponent;
  Form4: FormGroup;
  public activity1Model: Activity1;
  public activity2Model: Activity2;
  public activity3Model: Activity3;
  public activity4Model: Activity4;
  public activity5Model: Activity5;
  declarationList = [];
  clicked = false;
  //declaration4Data: SaveFormDeclarationLocalData;
  dNET: any; dTVA: any;
  a1NET: number; a1TVA: number; a2NET: number; a2TVA: number; a3NET: number; a3TVA: number; a4NET: number; a5NET: number;
  remarks: any;
  isDataEntered = false;
  percent1: number; percent2: number; percent3: number; percent4: number; percent5: number;
  Total: any;
  msgMaxPercentageError: boolean = false;
  capacity: any;
  totalPercentage: number;
  msgErrorPercent: boolean = false;
  saveFormDeclarationModel: SaveFormDeclaration;
  sumOfActivityNetAmt: number;
  msgErrorNET: boolean = false;
  msgErrorFieldMissing: boolean = false;
  form4Data: any;
  clientsData: any;
  Year: any;
  activitiesData: any = [];
  activitiesCollection = [];
  isActivity4Present: boolean;
  isActivity5Present: boolean;
  isActivity1Present: boolean;
  isActivity2Present: boolean;
  isActivity3Present: boolean;
  IsTVAWarningMsgEnable: boolean = false;
  msgErrorNotSaved: boolean = false;
  headerData: any[];
  savedForm4Data: any;
  selectedDeclarationNo : number;
  isPercentageCheckRequired: boolean = true;
  dataXML: any;
  xmlFile: any;
  declaration: any;
  today = new Date();
  jstoday = '';
  declaration4Data = {
    FormType: "",
    FormSubType: "",
    ContractNummer: "",
    AccountNumber: "",
    User: 0,
    dataXML: {
      XMLFile: {
        Header:
        {
          QualCiv: "",
          Nom: "",
          Prenom: "",
          NoClient: 0,
          RegimeLinguistique: 0,
          Email: "",
          Rue: "",
          NoRue: "",
          CodePostal: 0,
          Localite: "",
          LibellePays: ""
        },
        Declaration: [
          {
            Comment: "",
            contrat: [],
            Exercice: 0,
            PeriodeDebut: '',
            PeriodeFin: '',
            NoDeclaration: 0,
            NoProgressif: 0,
            Genre: "O",
            noIntervenantDestinataire: 0,
            NomDestinataire: "",
            PrenomDestinataire: "",
            RoleDestinataire: "",
            Statut: "",
            Libelle: "",
            CodeMontantBrut: "",
            MontantBrut: 0,
            CodeMontantNet: '',
            MontantNet: 0,
            CodeMontantTVA: '',
            MontantTVA: 0,
            TVAApplicable: 1,
            CodeActivite: "",
            Activite: [
              {
                TVAApplicable: 0,
                CodeActivite: "",
                Libelle: "",
                CodeMontantBrut: "",
                CodeMontantNet: "",
                CodeMontantTVA: "",
                MontantNet: 0,
                MontantTVA: 0,
                MontantBrut: 0,
                CodeRepartition: "",
                Pourcent: 0
              },
              {
                TVAApplicable: 0,
                CodeActivite: "",
                Libelle: "",
                CodeMontantBrut: "",
                CodeMontantNet: "",
                CodeMontantTVA: "",
                MontantNet: 0,
                MontantTVA: 0,
                MontantBrut: 0,
                CodeRepartition: "",
                Pourcent: 0
              },
              {
                TVAApplicable: 0,
                CodeActivite: "",
                Libelle: "",
                CodeMontantBrut: "",
                CodeMontantNet: "",
                CodeMontantTVA: "",
                MontantNet: 0,
                MontantTVA: 0,
                MontantBrut: 0,
                CodeRepartition: "",
                Pourcent: 0
              },
              {
                TVAApplicable: 0,
                CodeActivite: "",
                Libelle: "",
                CodeMontantBrut: "",
                CodeMontantNet: "",
                CodeMontantTVA: "",
                MontantNet: 0,
                MontantTVA: 0,
                MontantBrut: 0,
                CodeRepartition: "",
                Pourcent: 0
              },
              {
                TVAApplicable: 0,
                CodeActivite: "",
                Libelle: "",
                CodeMontantBrut: "",
                CodeMontantNet: "",
                CodeMontantTVA: "",
                MontantNet: 0,
                MontantTVA: 0,
                MontantBrut: 0,
                CodeRepartition: "",
                Pourcent: 0
              },
            ],
            LastModifiedDate: "",
            CodePourcentTot: 0,
            independant: [

            ]
          }
        ]
      }
    }
  }
  submissionDateTime: number;
  FormsData: any = [];
  SavedData: any;
  Declaration4Data: any;
  msgErrorMax30Percent: boolean = false;

  constructor(private _router: Router, private service: DeclarationService,
    private formBuilder: FormBuilder, public sharingService: SharingService, private decimal: DecimalPipe,
    private formatPipe: NumberFormatPipe) {
    this.activity1Model = new Activity1();
    this.activity2Model = new Activity2();
    this.activity3Model = new Activity3();
    this.activity4Model = new Activity4();
    this.activity5Model = new Activity5();
  }

  ngOnInit(): void {

    this.Form4 = this.formBuilder.group({
      MNet: ['', [Validators.required,Validators.maxLength(14)]],
      MTva: ['', [Validators.maxLength(14)]],
      activity1Net: ['',[Validators.required,Validators.maxLength(14)]],
      activity1Percent: ['',[Validators.required,Validators.maxLength(5)]],
      activity1Tva: ['', [Validators.maxLength(14)]],
      activity2Net: ['', [Validators.required,Validators.maxLength(14)]],
      activity2Percent: ['',[Validators.required,Validators.maxLength(5)]],
      activity2Tva: ['', [Validators.maxLength(14)]],
      activity3Net: ['', [Validators.required,Validators.maxLength(14)]],
      activity3Percent: ['',[Validators.required,Validators.maxLength(5)]],
      activity3Tva: ['', [Validators.maxLength(14)]],
      activity4Net: ['', [Validators.required,Validators.maxLength(14)]],
      activity4Percent: ['',[Validators.required,Validators.maxLength(5)]],
      activity4Tva: ['', [Validators.maxLength(14)]],
      activity5Net: ['', [Validators.required,Validators.maxLength(14)]],
      activity5Percent: ['',[Validators.required,Validators.maxLength(5)]],
      activity5Tva: ['', [Validators.maxLength(14)]],
      remarks: ['']
    });

    //Get all the Forms data - 
    this.FormsData = JSON.parse(sessionStorage.getItem("FormsData"));
    let selectedForm = JSON.parse(sessionStorage.getItem("selectedFormData"));
    this.selectedDeclarationNo = selectedForm.NoDeclaration;
    //Get Saved Data from Cache -
    this.savedForm4Data = JSON.parse(sessionStorage.getItem("SavedDeclaration4CachedData"));

    if (sessionStorage.getItem('isForm4Saved') == 'true' && this.savedForm4Data !== null) {
      this.declaration4Data = this.savedForm4Data;
      this.dataXML = this.declaration4Data.dataXML;
      this.xmlFile = this.dataXML.XMLFile;
      var declaration = this.xmlFile.Declaration;

      declaration.forEach(element => {
        if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo) {
          this.savedForm4Data = element;
        }
      });

      this.savedForm4Data.Activite.forEach(element => {
        if (element !== null) {
          this.activitiesData.push(element);
        }
      });

      this.form4Data = this.savedForm4Data;
      //Disable TVA Applicable -
      if (Number(this.form4Data.TVAApplicable == 0 || this.form4Data.TVAApplicable == null)) {
        this.DisableEnableControl('MTva', false);
        this.IsTVAWarningMsgEnable = true;
      }​​​​​​

      //Assign Declaration level NET TVA Value -
      this.dNET = this.form4Data.MontantNet;
      this.dTVA = this.form4Data.MontantTVA;
      this.Total = this.form4Data.MontantBrut;
      this.remarks = this.form4Data.Comment;

      if (!(this.dNET == 0 && this.form4Data.CodePourcentTot == 0)) {
        if (this.form4Data.CodePourcentTot == 100) {
          this.DisableNetTVAControlls();
        }
        else
          this.DisablePercentageControlls();
      }
    }
    // Initial Load from Dashboard (Not saved data) -
    else {
      this.form4Data = JSON.parse(sessionStorage.getItem("selectedFormData"));
      var activitiesCollection = this.form4Data.Activite;
      activitiesCollection.forEach(element => {
        if (element != null && element.CodeActivite !== '' && element.Libelle !== '') {
          this.activitiesData.push(element);
        }
      });
      //Disable TVA Applicable -
      if (Number(this.form4Data.TVAApplicable == 0 || this.form4Data.TVAApplicable == null)) {
        this.DisableEnableControl('MTva', false);
        this.IsTVAWarningMsgEnable = true;
      }​​​​​​
      this.dNET = this.form4Data.MontantNet == '' || this.form4Data.MontantNet == '0' ? 0 :this.conversionCommaToDot(this.form4Data.MontantNet);
      this.dTVA = this.form4Data.MontantTVA == '' || this.form4Data.MontantTVA == '0' ? 0 : this.conversionCommaToDot(this.form4Data.MontantTVA);
      this.Total = this.form4Data.MontantBrut == '' || this.form4Data.MontantBrut == '0' ? 0 : Number(this.form4Data.MontantBrut);
      this.remarks = this.form4Data.Comment;
      if (!(Number(this.dNET) == 0 && Number(this.form4Data.CodePourcentTot) == 0)) {
        if (Number(this.form4Data.CodePourcentTot) == 100) {
          this.DisableNetTVAControlls();
        }
        else
          this.DisablePercentageControlls();
      }
      else {
        this.EnablePercentageControlls();
        this.EnabledNetTVAControlls();
      }
      sessionStorage.setItem('isForm4Saved', 'false');
    }
    //Get client details -
    this.clientsData = JSON.parse(sessionStorage.getItem("SelectedClientData"));

    if (this.activitiesData[0] !== undefined && this.activitiesData[0].CodeActivite != "") {
      this.isActivity1Present = true;
      this.activity1Model.ActivityNo = this.activitiesData[0].CodeActivite;
      this.activity1Model.Label = this.activitiesData[0].Libelle;
      this.activity1Model.TVAApplicable = this.activitiesData[0].TVAApplicable == 1 ? true : false;
      if (this.form4Data.CodePourcentTot == 100) {
        this.DisableNetTVAControlls();
      }
      else
        this.DisableActivity1TVA();
      this.activity1Model.TVA = this.activitiesData[0].MontantTVA == '' ? 0 : Number(this.activitiesData[0].MontantTVA);
      this.activity1Model.Net = this.activitiesData[0].MontantNet == '' ? 0 : Number(this.activitiesData[0].MontantNet);
      this.activity1Model.Percentage = this.activitiesData[0].Pourcent == '' ? 0 : Number(this.activitiesData[0].Pourcent);
      this.activity1Model.Total = Number(this.activitiesData[0].MontantBrut);
    }
    else {
      this.isActivity1Present = false;
      this.activity1Model.Percentage = undefined;
    }

    if (this.activitiesData[1] !== undefined && this.activitiesData[1].CodeActivite != "") {
      this.isActivity2Present = true;
      this.activity2Model.ActivityNo = this.activitiesData[1].CodeActivite;
      this.activity2Model.Label = this.activitiesData[1].Libelle;
      this.activity2Model.TVAApplicable = this.activitiesData[1].TVAApplicable == 1 ? true : false;
      if (this.form4Data.CodePourcentTot == 100) {
        this.DisableNetTVAControlls();
      }
      else
        this.DisableActivity2TVA();
      this.activity2Model.TVA = this.activitiesData[1].MontantTVA == '' ? 0 : Number(this.activitiesData[1].MontantTVA);
      this.activity2Model.Net = this.activitiesData[1].MontantNet == '' ? 0 : Number(this.activitiesData[1].MontantNet);
      this.activity2Model.Percentage = this.activitiesData[1].Pourcent == '' ? 0 : Number(this.activitiesData[1].Pourcent);
      this.activity2Model.Total = Number(this.activitiesData[1].MontantBrut);
    }
    else {
      this.isActivity2Present = false;
      this.activity2Model.Percentage = undefined;
    }

    if (this.activitiesData[2] !== undefined && this.activitiesData[2].CodeActivite != "") {
      this.isActivity3Present = true;
      this.activity3Model.ActivityNo = this.activitiesData[2].CodeActivite;
      this.activity3Model.Label = this.activitiesData[2].Libelle;
      this.activity3Model.TVAApplicable = this.activitiesData[2].TVAApplicable == 1 ? true : false;
      if (this.form4Data.CodePourcentTot == 100) {
        this.DisableNetTVAControlls();
      }
      else
        this.DisableActivity3TVA();
      this.activity3Model.TVA = this.activitiesData[2].MontantTVA == '' ? 0 : Number(this.activitiesData[2].MontantTVA);
      this.activity3Model.Net = this.activitiesData[2].MontantNet == '' ? 0 : Number(this.activitiesData[2].MontantNet);
      this.activity3Model.Percentage = this.activitiesData[2].Pourcent == '' ? 0 : Number(this.activitiesData[2].Pourcent);
      this.activity3Model.Total = Number(this.activitiesData[2].MontantBrut);
    }
    else {
      this.isActivity3Present = false;
      this.activity3Model.Percentage = undefined;
    }
    if (this.activitiesData[3] !== undefined && this.activitiesData[3].CodeActivite != "") {
      this.isActivity4Present = true;
      this.activity4Model.ActivityNo = this.activitiesData[3].CodeActivite;
      this.activity4Model.Label = this.activitiesData[3].Libelle;
      this.activity4Model.TVAApplicable = this.activitiesData[3].TVAApplicable == 1 ? true : false;
      if (this.form4Data.CodePourcentTot == 100) {
        this.DisableNetTVAControlls();
      }
      else
        this.DisableActivity4TVA();
      this.activity4Model.TVA = this.activitiesData[3].MontantTVA == '' ? 0 : Number(this.activitiesData[3].MontantTVA);
      this.activity4Model.Net = this.activitiesData[3].MontantNet == '' ? 0 : Number(this.activitiesData[3].MontantNet);
      this.activity4Model.Percentage = this.activitiesData[3].Pourcent == '' ? 0 : Number(this.activitiesData[3].Pourcent);
      this.activity4Model.Total = Number(this.activitiesData[3].MontantBrut);
    }
    else {
      this.isActivity4Present = false;
      this.activity4Model.Percentage = undefined;
    }
    if (this.activitiesData[4] !== undefined && this.activitiesData[4].CodeActivite != "") {
      this.isActivity5Present = true;
      this.activity5Model.ActivityNo = this.activitiesData[4].CodeActivite;
      this.activity5Model.Label = this.activitiesData[4].Libelle;
      this.activity5Model.TVAApplicable = this.activitiesData[4].TVAApplicable == 1 ? true : false;
      if (this.form4Data.CodePourcentTot == 100) {
        this.DisableNetTVAControlls();
      }
      else
        this.DisableActivity5TVA();
      this.activity5Model.TVA = this.activitiesData[4].MontantTVA == '' ? 0 : Number(this.activitiesData[4].MontantTVA);
      this.activity5Model.Net = this.activitiesData[4].MontantNet == '' ? 0 : Number(this.activitiesData[4].MontantNet);
      this.activity5Model.Percentage = this.activitiesData[4].Pourcent == '' ? 0 : Number(this.activitiesData[4].Pourcent);
      this.activity5Model.Total = Number(this.activitiesData[4].MontantBrut);
    }
    else {
      this.isActivity5Present = false;
      this.activity5Model.Percentage = undefined;
    }
    var s = { target : { value : this.dNET.toString()}};
    this.formatOnFocusOut(s,'DNET');
  }

  formatOnFocusIn(s){
    if(s.target.value === '0' || s.target.value === '0,00'){
      s.target.value = '';
    }   

    s.target.value =  s.target.value.replace(/\./g, '');   
    s.target.value =  s.target.value.replace(/\,/g, '.');
    
    
    const commaIndex = s.target.value.indexOf(',');
    if(commaIndex >- 1){ 
    s.target.value = this.replaceAt(s.target.value,commaIndex,'.');
    }
    // const dotIndex =  s.target.value.indexOf('.');
    // if(dotIndex > -1){
    //   s.target.value  = s.target.value ;
    // }
  }

  validateOperator(s){
    var t = s.target.value;  
    
    
    if(s.keyCode === 190 || s.keyCode === 110 || s.keyCode === 46 || s.keyCode === 188 || s.keyCode === 44){//comma
     if(t.match(/[,]/g) !== null){
      if(t.match(/[,]/g).length > 1){
        return false;
      } 
     }

     if(t.match(/[.]/g) !== null){  
      if(t.match(/[.]/g).length > 1){
        return false;
      } 
     }
     
      // if(t.match(/[,]/g).length > 1 || t.match(/[.]/g).length > 1){
      //   return false;
      // } 
    }
  }



  validateDecimal(s){
    var t = s.target.value; 
    let skipCharcode = [44,46,190]; //110  : Removed 110 for Bug :54601
    const charCode = s.which ? s.which : s.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) &&  skipCharcode.indexOf(charCode) === -1) {
      return false;
    }
    //this.numberandDecimal(s);
    //dot and comma
    if(t.match(/[.]/g) !== null){
      if( t.match(/[.]/g).length > 1 || (s.keyCode === 190 || s.keyCode === 110 || s.keyCode === 46)){
        return false;
      }
      
      if(s.keyCode === 44 || s.keyCode === 188){
        return false;
      }
    }
//comma and dot
    if(t.match(/[,]/g) !== null){
      if( t.match(/[,]/g).length > 1 || (s.keyCode === 44 || s.keyCode === 188)){
        return false;
      }
      
      if(s.keyCode === 190 || s.keyCode === 110 || s.keyCode === 46){
        return false;
      }
    }

    if(s.keyCode === 190 || s.keyCode === 110 || s.keyCode === 46){
      if(t.match(/[.]/g) !== null){
        if( t.match(/[.]/g).length > 1){
          return false;
        }
      }
     
    }
    else{
      if((t.indexOf(".") > -1)){
        //s.target.value = (t.indexOf(".") >= 0) ? (t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 2)) : t;
        //s.target.value = t.split('.')[1].length < 2 ? t : t;
        if(t.split('.')[1].length < 2){
          s.target.value = t;
        }else{    
          return false;
        }
      }
      
      if((t.indexOf(",") > -1)){
        s.target.value = (t.indexOf(",") >= 0) ? 
        (t.substr(0, t.indexOf(",")) + t.substr(t.indexOf(","), 2)) :
        t;
      }
      
    }
     
    
  }

  clipboardPaste($event){
    console.log($event);
    const clipbaordData = $event.clipboardData.getData('Text');
    let s = {
      target: {
        value : clipbaordData
      }
    };

    let numericData = clipbaordData.replace(/[^0-9,.]/g, '');
   
//123,456,789=> 123456,789
//123.456.789=> 123456,789
let formatedData;
if(numericData.lastIndexOf(',') > -1){
  formatedData = numericData.substr(0,numericData.lastIndexOf(',')).replace(/\,/g,'').replace(/\./g,'') + numericData.slice(numericData.lastIndexOf(',')).replace(/\./g, '');
}else
if(numericData.lastIndexOf('.') > -1){
  formatedData = numericData.substr(0,numericData.lastIndexOf('.')).replace(/\./g,'').replace(/\,/g,'') + numericData.slice(numericData.lastIndexOf('.'));
}
  

s.target.value = formatedData;

$event.preventDefault();
 $event.target.value = formatedData.indexOf(',') > -1  ? formatedData : parseFloat(formatedData).toFixed(2);;

   

  }

  conversionDotToComma(val){
    if(typeof val === 'undefined' || val === null || val === 0)
    return val;

   // const dotIndex = val.indexOf('.');    
    return this.formatPipe.transform(val);
  }

  conversionCommaToDot(val){
    if(typeof val === 'undefined' || val === null || val === 0)
    return val;
    
    let tmpindexdot = val.toString().length - val.toString().lastIndexOf('.');
    if( tmpindexdot == 2 || tmpindexdot == 3 )
    return Number(val);

    val =  val.toString().replace(/\./g, '');   
    val =  val.toString().replace(/\,/g, '.');    
    
    const commaIndex = val.indexOf(',');
    if(commaIndex >- 1){ 
      val = this.replaceAt(val,commaIndex,'.');
    }
    return Number(val);
  }

  formatOnFocusOut(s,modelname?){    
    if(s.target.value === ''){
      s.target.value = '0';
    }else{    
      const dotIndex = s.target.value.indexOf('.');    
      switch(modelname){
        case 'DNET':
          this.dNET =  this.formatPipe.transform(s.target.value);
          break;
        case 'DTVA':
          this.dTVA =  this.formatPipe.transform(s.target.value);
          break;
        case 'ACTIVITY1MODEL.NET':
            this.activity1Model.Net= this.formatPipe.transform(s.target.value);
            break;
        case 'ACTIVITY1MODEL.TVA':
            this.activity1Model.TVA= this.formatPipe.transform(s.target.value);
            break;
        case 'ACTIVITY2MODEL.NET':
            this.activity2Model.Net= this.formatPipe.transform(s.target.value);
            break;
        case 'ACTIVITY1MODEL.TVA':
            this.activity2Model.TVA= this.formatPipe.transform(s.target.value);
            break;
        case 'ACTIVITY3MODEL.NET':
            this.activity3Model.Net= this.formatPipe.transform(s.target.value);
            break;
        case 'ACTIVITY3MODEL.TVA':
            this.activity3Model.TVA= this.formatPipe.transform(s.target.value);
            break;
        case 'ACTIVITY4MODEL.NET':
            this.activity4Model.Net= this.formatPipe.transform(s.target.value);
            break;
          case 'ACTIVITY4MODEL.TVA':
            this.activity4Model.TVA= this.formatPipe.transform(s.target.value);
            break;
        case 'ACTIVITY5MODEL.NET':
            this.activity5Model.Net= this.formatPipe.transform(s.target.value);
            break;
        case 'ACTIVITY5MODEL.TVA':
            this.activity5Model.TVA= this.formatPipe.transform(s.target.value);
            break;
        case 'ACTIVITY1MODEL.PER':
            this.activity1Model.Percentage= this.formatPipe.transform(s.target.value);
            break;
        case 'ACTIVITY2MODEL.PER':
            this.activity2Model.Percentage= this.formatPipe.transform(s.target.value);
            break;
        case 'ACTIVITY3MODEL.PER':
            this.activity3Model.Percentage= this.formatPipe.transform(s.target.value);
            break;
        case 'ACTIVITY4MODEL.PER':
            this.activity4Model.Percentage= this.formatPipe.transform(s.target.value);
            break;
        case 'ACTIVITY5MODEL.PER':
            this.activity5Model.Percentage= this.formatPipe.transform(s.target.value);
            break;
      }
      
      s.target.value = this.formatPipe.transform(s.target.value);
    }    
  }

  replaceAt = function(val,index, replacement) {
    if (index >= val.length) {
        return val.valueOf();
    } 
    return val.substring(0, index) + replacement + val.substring(index + 1);
}



  //Enable or Disable Control -
  DisableEnableControl(name: any, IsEnable: boolean): void {
    let ctrl = this.Form4.controls[name];
    IsEnable ? ctrl.enable() : ctrl.disable();
  }

  //Disable Percentage on NET TVA entered -
  disablePercent(event: any) {
    // 1
    if (this.activity1Model.Net > 999999999) {
      event.preventDefault()
      this.activity1Model.Net = parseInt(this.activity1Model.Net.toString().substring(0, 9));
    }
    if (this.activity1Model.TVA > 999999999) {
      event.preventDefault()
      this.activity1Model.TVA = parseInt(this.activity1Model.TVA.toString().substring(0, 9));
    }
    this.activity1Model.Total = this.activity1Model.Net || this.activity1Model.TVA ? (this.activity1Model.Net && this.activity1Model.TVA ? this.activity1Model.Net + this.activity1Model.TVA : this.activity1Model.Net || this.activity1Model.TVA) : 0
    // 2
    if (this.activity2Model.Net > 999999999) {
      event.preventDefault()
      this.activity2Model.Net = parseInt(this.activity2Model.Net.toString().substring(0, 9));
    }
    if (this.activity2Model.TVA > 999999999) {
      event.preventDefault()
      this.activity2Model.TVA = parseInt(this.activity2Model.TVA.toString().substring(0, 9));
    }
    this.activity2Model.Total = this.activity2Model.Net || this.activity2Model.TVA ? (this.activity2Model.Net && this.activity2Model.TVA ? this.activity2Model.Net + this.activity2Model.TVA : this.activity2Model.Net || this.activity2Model.TVA) : 0

    // 3
    if (this.activity3Model.Net > 999999999) {
      event.preventDefault()
      this.activity3Model.Net = parseInt(this.activity3Model.Net.toString().substring(0, 9));
    }
    if (this.activity3Model.TVA > 999999999) {
      event.preventDefault()
      this.activity3Model.TVA = parseInt(this.activity3Model.TVA.toString().substring(0, 9));
    }
    this.activity3Model.Total = this.activity3Model.Net || this.activity3Model.TVA ? (this.activity3Model.Net && this.activity3Model.TVA ? this.activity3Model.Net + this.activity3Model.TVA : this.activity3Model.Net || this.activity3Model.TVA) : 0
    // 4
    if (this.activity4Model.Net > 999999999) {
      event.preventDefault()
      this.activity4Model.Net = parseInt(this.activity4Model.Net.toString().substring(0, 9));
    }
    if (this.activity4Model.TVA > 999999999) {
      event.preventDefault()
      this.activity4Model.TVA = parseInt(this.activity4Model.TVA.toString().substring(0, 9));
    }
    this.activity4Model.Total = this.activity4Model.Net || this.activity4Model.TVA ? (this.activity4Model.Net && this.activity4Model.TVA ? this.activity4Model.Net + this.activity4Model.TVA : this.activity4Model.Net || this.activity4Model.TVA) : 0

    // 5
    if (this.activity5Model.Net > 999999999) {
      event.preventDefault()
      this.activity5Model.Net = parseInt(this.activity5Model.Net.toString().substring(0, 9));
    }
    if (this.activity5Model.TVA > 999999999) {
      event.preventDefault()
      this.activity5Model.TVA = parseInt(this.activity5Model.TVA.toString().substring(0, 9));
    }
    this.activity5Model.Total = this.activity5Model.Net || this.activity5Model.TVA ? (this.activity5Model.Net && this.activity5Model.TVA ? this.activity5Model.Net + this.activity5Model.TVA : this.activity5Model.Net || this.activity5Model.TVA) : 0

    if (this.activity1Model.Total > 0 || this.activity2Model.Total > 0 || this.activity3Model.Total > 0 || this.activity4Model.Total > 0 || this.activity5Model.Total > 0) {
      this.isDataEntered = true;
      this.DisablePercentageControlls();
    }
    else if (this.activity1Model.Total == 0 && this.activity2Model.Total == 0 && this.activity3Model.Total == 0 && this.activity4Model.Total == 0 && this.activity5Model.Total == 0) {
      this.EnablePercentageControlls();
    }
  }
  // Disable NET & TVA on Percentage entered -
  disableControl(event: any) {
    if (this.activity1Model.Percentage > 100) {
      event.preventDefault()
      this.activity1Model.Percentage = parseInt(this.activity1Model.Percentage.toString().substring(0, 2));
    }
    if (this.activity2Model.Percentage > 100) {
      event.preventDefault()
      this.activity2Model.Percentage = parseInt(this.activity2Model.Percentage.toString().substring(0, 2));
    }
    if (this.activity3Model.Percentage > 100) {
      event.preventDefault()
      this.activity3Model.Percentage = parseInt(this.activity3Model.Percentage.toString().substring(0, 2));
    }
    if (this.activity4Model.Percentage > 100) {
      event.preventDefault()
      this.activity4Model.Percentage = parseInt(this.activity4Model.Percentage.toString().substring(0, 2));
    }
    if (this.activity5Model.Percentage > 100) {
      event.preventDefault()
      this.activity5Model.Percentage = parseInt(this.activity5Model.Percentage.toString().substring(0, 2));
    }
    if (this.activity1Model.Percentage !== (null && undefined) || this.activity2Model.Percentage !== (null && undefined) || this.activity3Model.Percentage !== (null && undefined) || this.activity4Model.Percentage !== (null && undefined) || this.activity5Model.Percentage !== (null && undefined)) {
      this.isDataEntered = true;
      this.DisableNetTVAControlls();
    }
    if (this.activity1Model.Percentage == (null || 0 || undefined) && this.activity2Model.Percentage == (null || 0 || undefined) && this.activity3Model.Percentage == (null || 0 || undefined) && this.activity4Model.Percentage == (null || 0 || undefined) && this.activity5Model.Percentage == (null || 0 || undefined)) {
      this.EnabledNetTVAControlls();
    }
  }

  //Calculate total for 1st Activity -
  calculateTotal(event: any) {
    this.isDataEntered = true;
    if (this.conversionCommaToDot(this.dNET) > 999999999) {
      event.preventDefault()
      this.dNET = parseInt(this.conversionCommaToDot(this.dNET).toString().substring(0, 9));
    }
    if (this.conversionCommaToDot(this.dTVA) > 999999999) {
      event.preventDefault()
      this.dTVA = parseInt(this.conversionCommaToDot(this.dTVA).toString().substring(0, 9));
    }
    this.Total = this.conversionCommaToDot(this.dNET)|| this.conversionCommaToDot(this.dTVA) ? (this.conversionCommaToDot(this.dNET) && this.conversionCommaToDot(this.dTVA) ? 
    this.conversionCommaToDot(this.dNET) + this.conversionCommaToDot(this.dTVA) : this.conversionCommaToDot(this.dNET) || (this.dTVA)) : 0;

    this.Total = this.conversionDotToComma(this.Total);
  }
  remarksEntered() {
    if (this.remarks !== null && this.remarks !== undefined) {
      this.isDataEntered = true;
    }
  }
  //Validate & Save -
  ValidateAndSaveForm4() {

    this.ClearMsgFields();
    if (this.dNET == undefined || this.dNET == null) {
      this.msgErrorFieldMissing = true;
      return false;
    }
    if (this.TVAThreasholdCheck(this.dNET, this.dTVA)) {
      this.msgErrorMax30Percent = true;
      return false;
    }

    this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
      if (element.Genre == 'O') {
        element.NoDeclaration = this.selectedDeclarationNo;
      }
    });

    this.percent1 = !this.isActivity1Present && this.activity1Model.Percentage == undefined ? 0 : this.conversionCommaToDot(this.activity1Model.Percentage);
    this.percent2 = !this.isActivity2Present && this.activity2Model.Percentage == undefined ? 0 : this.conversionCommaToDot(this.activity2Model.Percentage);
    this.percent3 = !this.isActivity3Present && this.activity3Model.Percentage == undefined ? 0 : this.conversionCommaToDot(this.activity3Model.Percentage);
    this.percent4 = !this.isActivity4Present && this.activity4Model.Percentage == undefined ? 0 : this.conversionCommaToDot(this.activity4Model.Percentage);
    this.percent5 = !this.isActivity5Present && this.activity5Model.Percentage == undefined ? 0 : this.conversionCommaToDot(this.activity5Model.Percentage);

    this.totalPercentage = this.percent1 + this.percent2 + this.percent3 + this.percent4 + this.percent5;

    if (this.totalPercentage !== 0) {
      if (this.totalPercentage > 100 || this.totalPercentage < 100) {
        this.msgErrorPercent = true;
        this.msgErrorFieldMissing = false;
        this.msgErrorNET = false;
        this.msgMaxPercentageError = false;
        return false;
      }
      else {
        this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
          if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo) {
            element.CodePourcentTot = 100;
          }
        });
      }
    }
    // Percentage Fields check & Save-
    if (this.percent1 > 0 || this.percent2 > 0 || this.percent3 > 0 || this.percent4 > 0 || this.percent5 > 0) {
      if (this.isActivity1Present) {
        if (this.activity1Model.Percentage == (undefined || null)) {
          this.msgErrorFieldMissing = true;
          return false;
        }
        else {
          this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
            if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo && element.Activite !== null) {
              element.Activite[0].Libelle = this.activity1Model.Label == undefined ? '' : this.activity1Model.Label;
              element.Activite[0].Pourcent = this.activity1Model.Percentage;
              element.Activite[0].CodeActivite = this.activity1Model.ActivityNo;
              element.Activite[0].CodeRepartition = 'OREPPOURC';
              element.Activite[0].CodeMontantBrut = 'OFACTTOT';
              element.Activite[0].CodeMontantNet = 'OFACTNET';
              element.Activite[0].CodeMontantTVA = 'OFACTTVA';
              element.Activite[0].MontantNet = 0; element.Activite[0].MontantTVA = 0; element.Activite[0].MontantBrut = 0;
            }
          });
        }
      }
      if (this.isActivity2Present) {
        if (this.activity2Model.Percentage == (undefined || null)) {
          this.msgErrorFieldMissing = true;
          return false;
        }
        else {
          this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
            if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo && element.Activite !== null) {
              element.Activite[1].Libelle = this.activity2Model.Label == undefined ? '' : this.activity2Model.Label;
              element.Activite[1].Pourcent = this.activity2Model.Percentage;
              element.Activite[1].CodeActivite = this.activity2Model.ActivityNo;
              element.Activite[1].CodeRepartition = 'OREPPOURC';
              element.Activite[1].CodeMontantBrut = 'OFACTTOT';
              element.Activite[1].CodeMontantNet = 'OFACTNET';
              element.Activite[1].CodeMontantTVA = 'OFACTTVA';
              element.Activite[1].MontantNet = 0; element.Activite[1].MontantTVA = 0; element.Activite[1].MontantBrut = 0;
            }
          });
        }
      }
      if (this.isActivity3Present) {
        if (this.activity3Model.Percentage == (undefined || null)) {
          this.msgErrorFieldMissing = true;
          return false;
        }
        else {
          this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
            if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo && element.Activite !== null) {
              element.Activite[2].Libelle = this.activity3Model.Label == undefined ? '' : this.activity3Model.Label;
              element.Activite[2].Pourcent = this.activity3Model.Percentage;
              element.Activite[2].CodeActivite = this.activity3Model.ActivityNo;
              element.Activite[2].CodeRepartition = 'OREPPOURC';
              element.Activite[2].CodeMontantBrut = 'OFACTTOT';
              element.Activite[2].CodeMontantNet = 'OFACTNET';
              element.Activite[2].CodeMontantTVA = 'OFACTTVA';
              element.Activite[2].MontantNet = 0; element.Activite[2].MontantTVA = 0; element.Activite[2].MontantBrut = 0;
            }
          });
        }
      }
      if (this.isActivity4Present) {
        if (this.activity4Model.Percentage == (undefined || null)) {
          this.msgErrorFieldMissing = true;
          return false;
        }
        else {
          this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
            if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo && element.Activite !== null) {
              element.Activite[3].Libelle = this.activity4Model.Label == undefined ? '' : this.activity4Model.Label;
              element.Activite[3].Pourcent = this.activity4Model.Percentage;
              element.Activite[3].CodeActivite = this.activity4Model.ActivityNo;
              element.Activite[3].CodeRepartition = 'OREPPOURC';
              element.Activite[3].CodeMontantBrut = 'OFACTTOT';
              element.Activite[3].CodeMontantNet = 'OFACTNET';
              element.Activite[3].CodeMontantTVA = 'OFACTTVA';
              element.Activite[3].MontantNet = 0; element.Activite[3].MontantTVA = 0; element.Activite[3].MontantBrut = 0;
            }
          });
        }
      }
      if (this.isActivity5Present) {
        if (this.activity5Model.Percentage == (undefined || null)) {
          this.msgErrorFieldMissing = true;
          return false;
        }
        else {
          this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
            if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo && element.Activite !== null) {
              element.Activite[4].Libelle = this.activity5Model.Label == undefined ? '' : this.activity5Model.Label;
              element.Activite[4].Pourcent = this.activity5Model.Percentage;
              element.Activite[4].CodeActivite = this.activity5Model.ActivityNo;
              element.Activite[4].CodeRepartition = 'OREPPOURC';
              element.Activite[4].CodeMontantBrut = 'OFACTTOT';
              element.Activite[4].CodeMontantNet = 'OFACTNET';
              element.Activite[4].CodeMontantTVA = 'OFACTTVA';
              element.Activite[4].MontantNet = 0; element.Activite[4].MontantTVA = 0; element.Activite[4].MontantBrut = 0;
            }
          });
        }
      }

      this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
        if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo) {
          element.MontantTVA = this.conversionCommaToDot(this.dTVA);
          element.MontantNet = this.conversionCommaToDot(this.dNET);
          element.Statut = "ACTIVE";
        }
      });

      this.PrepareFormRootData();
      this.PrepareHeaderData();
      this.PrepareDeclarationData();
      this.ClearNETTVAFields();
      this.DeleteUnavailableActivity();

      if (this.FormsData !== null) {
        this.FormsData.forEach(element => {
          if (element.Genre == "O" && element.NoDeclaration == this.selectedDeclarationNo) {
            element.MontantTVA = this.conversionCommaToDot(this.dTVA);
            element.MontantNet = this.conversionCommaToDot(this.dNET);
            element.MontantBrut = this.conversionCommaToDot(this.Total);
            element.CodePourcentTot = 100;
            element.CodeMontantBrut = "OFACTTTOT";
            element.CodeMontantNet = "OFACTTNET";
            element.CodeMontantTVA = "OFACTTTVA";
            element.Statut = "ACTIVE";
            element.LastModifiedDate = formatDate(this.today, 'dd/MM/yyyy', 'en-US', '+0100');
            element.PeriodeDebut = element.PeriodeDebut == null ? "" : (element.PeriodeDebut.length == 10 ? element.PeriodeDebut : this.customDateFormat(element.PeriodeDebut));
            element.PeriodeFin = element.PeriodeFin == null ? "" : (element.PeriodeFin.length == 10 ? element.PeriodeFin : this.customDateFormat(element.PeriodeFin));
            element.Exercice = parseInt(sessionStorage.getItem("Year"));
            element.Comment = this.remarks;
            var activite = [];
            this.declaration4Data.dataXML.XMLFile.Declaration.forEach(item => {
              if (item.Genre == 'O' && item.NoDeclaration == this.selectedDeclarationNo) {
                item.Activite.forEach(e => {
                  if(activite.filter(u => u.CodeActivite === e.CodeActivite).length == 0)
                  {
                    activite.push(e);
                  }
                });
              }
            });
            element.Activite = activite;
          }
          else {
            this.declaration4Data.dataXML.XMLFile.Declaration.push(element);
          }
        });
      }
      this.declaration4Data.dataXML.XMLFile.Declaration = this.FormsData;
      this.SavedData = this.declaration4Data;
      var JsonForm4SaveDeclaration = JSON.stringify(this.declaration4Data);
      this.Declaration4Data = JSON.parse(JsonForm4SaveDeclaration);

      this.service.SaveDeclaration1(this.Declaration4Data).subscribe(
        (data) => {
          if (data == 'Failed') {
            this.msgErrorNotSaved = true;
            sessionStorage.setItem('isForm4Saved', 'false');
          }
          else {
            sessionStorage.setItem("FormsData", JSON.stringify(this.FormsData));
            sessionStorage.setItem("AllDeclarationData", JsonForm4SaveDeclaration);
            sessionStorage.setItem("SavedDeclaration1CachedData", JsonForm4SaveDeclaration);
            sessionStorage.setItem('isForm4Saved', 'true');
            sessionStorage.setItem('form4SubmittedDate', formatDate(this.today, 'dd/MM/yyyy', 'en-US', '+0100'));
            this.gotoDashboard();
          }
        },
        (err) => {
          this.msgErrorNotSaved = true;
        });

    }
    else { //NET TVA Value Check
      if (this.isActivity1Present && this.isActivity2Present) {
        if (this.activity1Model.Net == undefined || this.activity1Model.Net == null) {
          this.msgErrorFieldMissing = true;
          return false;
        }
        if (this.activity1Model.TVAApplicable) {
          this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
            if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo && element.Activite !== null) {
              element.Activite[0].MontantTVA = this.activity1Model.TVA;

            }
          });
          if (this.TVAThreasholdCheck(this.activity1Model.Net, this.activity1Model.TVA)) { //Threashold check
            this.msgErrorMax30Percent = true;
            return false;
          }
        }
        this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
          if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo && element.Activite !== null) {
            element.Activite[0].CodeActivite = this.activity1Model.ActivityNo;
            element.Activite[0].Libelle = this.activity1Model.Label == undefined ? '' : this.activity1Model.Label;
            element.Activite[0].MontantNet = this.activity1Model.Net;
            element.Activite[0].TVAApplicable = this.activity1Model.TVAApplicable ? 1 : 0;
            element.Activite[0].MontantBrut = this.activity1Model.Total;
            element.Activite[0].CodeMontantBrut = 'OFACTTOT';
            element.Activite[0].CodeMontantNet = 'OFACTNET';
            element.Activite[0].CodeMontantTVA = 'OFACTTVA';
          }
        });
      }
      else { //IF there is 1 Activity,Push the Contrat info to Activity 1 -
        this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
          if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo && element.Activite !== null) {
            element.Activite[0].CodeActivite = this.activity1Model.ActivityNo;
            element.Activite[0].Libelle = this.activity1Model.Label == undefined ? '' : this.activity1Model.Label;
            element.Activite[0].MontantNet = 0;
            element.Activite[0].MontantTVA = 0;
            element.Activite[0].TVAApplicable = this.activity1Model.TVAApplicable ? 1 : 0;
            element.Activite[0].MontantBrut = 0;
            element.Activite[0].CodeMontantBrut = 'OFACTTOT';
            element.Activite[0].CodeMontantNet = 'OFACTNET';
            element.Activite[0].CodeMontantTVA = 'OFACTTVA';
          }
        });
      }
      if (this.isActivity2Present) { //2
        if (this.activity2Model.Net == (undefined || null)) {
          this.msgErrorFieldMissing = true;
          return false;
        }
        if (this.activity2Model.TVAApplicable) {
          this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
            if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo && element.Activite !== null) {
              element.Activite[1].MontantTVA = this.activity2Model.TVA;

            }
          });
          if (this.TVAThreasholdCheck(this.activity2Model.Net, this.activity2Model.TVA)) { //Threashold check
            this.msgErrorMax30Percent = true;
            return false;
          }
        }
        this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
          if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo && element.Activite !== null) {
            element.Activite[1].CodeActivite = this.activity2Model.ActivityNo;
            element.Activite[1].Libelle = this.activity2Model.Label == undefined ? '' : this.activity2Model.Label;
            element.Activite[1].MontantNet = this.activity2Model.Net;
            element.Activite[1].TVAApplicable = this.activity2Model.TVAApplicable ? 1 : 0;
            element.Activite[1].MontantBrut = this.activity2Model.Total;
            element.Activite[1].CodeMontantBrut = 'OFACTTOT';
            element.Activite[1].CodeMontantNet = 'OFACTNET';
            element.Activite[1].CodeMontantTVA = 'OFACTTVA';
          }
        });
      }
      if (this.isActivity3Present) { //3
        if (this.activity3Model.Net == (undefined || null)) {
          this.msgErrorFieldMissing = true;
          return false;
        }
        if (this.activity3Model.TVAApplicable) {
          this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
            if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo && element.Activite !== null) {
              element.Activite[2].MontantTVA = this.activity3Model.TVA;

            }
          });
          if (this.TVAThreasholdCheck(this.activity3Model.Net, this.activity3Model.TVA)) { //Threashold check
            this.msgErrorMax30Percent = true;
            return false;
          }
        }
        this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
          if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo && element.Activite !== null) {
            element.Activite[2].CodeActivite = this.activity3Model.ActivityNo;
            element.Activite[2].Libelle = this.activity3Model.Label == undefined ? '' : this.activity3Model.Label;
            element.Activite[2].MontantNet = this.activity3Model.Net;
            element.Activite[2].TVAApplicable = this.activity3Model.TVAApplicable ? 1 : 0;
            element.Activite[2].MontantBrut = this.activity3Model.Total;
            element.Activite[2].CodeMontantBrut = 'OFACTTOT';
            element.Activite[2].CodeMontantNet = 'OFACTNET';
            element.Activite[2].CodeMontantTVA = 'OFACTTVA';
          }
        });
      }
      if (this.isActivity4Present) { //4
        if (this.activity4Model.Net == (undefined || null)) {
          this.msgErrorFieldMissing = true;
          return false;
        }
        if (this.activity4Model.TVAApplicable) {
          this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
            if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo && element.Activite !== null) {
              element.Activite[3].MontantTVA = this.activity4Model.TVA;

            }
          });
          if (this.TVAThreasholdCheck(this.activity4Model.Net, this.activity4Model.TVA)) { //Threashold check
            this.msgErrorMax30Percent = true;
            return false;
          }
        }
        this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
          if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo && element.Activite !== null) {
            element.Activite[3].CodeActivite = this.activity4Model.ActivityNo;
            element.Activite[3].Libelle = this.activity4Model.Label == undefined ? '' : this.activity4Model.Label;
            element.Activite[3].MontantNet = this.activity4Model.Net;
            element.Activite[3].TVAApplicable = this.activity4Model.TVAApplicable ? 1 : 0;
            element.Activite[3].MontantBrut = this.activity4Model.Total;
            element.Activite[3].CodeMontantBrut = 'OFACTTOT';
            element.Activite[3].CodeMontantNet = 'OFACTNET';
            element.Activite[3].CodeMontantTVA = 'OFACTTVA';
          }
        });
      }
      if (this.isActivity5Present) { //5
        if (this.activity5Model.Net == (undefined || null)) {
          this.msgErrorFieldMissing = true;
          return false;
        }
        if (this.activity5Model.TVAApplicable) {
          this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
            if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo && element.Activite !== null) {
              element.Activite[4].MontantTVA = this.activity5Model.TVA;

            }
          });
          if (this.TVAThreasholdCheck(this.activity5Model.Net, this.activity5Model.TVA)) { //Threashold check
            this.msgErrorMax30Percent = true;
            return false;
          }
        }

        this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
          if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo && element.Activite !== null) {
            element.Activite[4].CodeActivite = this.activity5Model.ActivityNo;
            element.Activite[4].Libelle = this.activity5Model.Label == undefined ? '' : this.activity5Model.Label;
            element.Activite[4].MontantNet = this.activity5Model.Net;
            element.Activite[4].TVAApplicable = this.activity5Model.TVAApplicable ? 1 : 0;
            element.Activite[4].MontantBrut = this.activity5Model.Total;
            element.Activite[4].CodeMontantBrut = 'OFACTTOT';
            element.Activite[4].CodeMontantNet = 'OFACTNET';
            element.Activite[4].CodeMontantTVA = 'OFACTTVA';
          }
        });
      }
      this.a1NET = !this.isActivity1Present && this.activity1Model.Net == undefined ? 0 : this.activity1Model.Net;
      this.a2NET = !this.isActivity2Present && this.activity2Model.Net == undefined ? 0 : this.activity2Model.Net;
      this.a3NET = !this.isActivity3Present && this.activity3Model.Net == undefined ? 0 : this.activity3Model.Net;
      this.a4NET = !this.isActivity4Present && this.activity4Model.Net == undefined ? 0 : this.activity4Model.Net;
      this.a5NET = !this.isActivity5Present && this.activity5Model.Net == undefined ? 0 : this.activity5Model.Net;
      this.sumOfActivityNetAmt = this.a1NET + this.a2NET + this.a3NET + this.a4NET + this.a5NET;
      this.sumOfActivityNetAmt = Number(this.sumOfActivityNetAmt.toFixed(2));
      if (this.isActivity1Present &&
        (this.isActivity2Present || this.isActivity3Present || this.isActivity4Present || this.isActivity5Present)) {
        if (this.sumOfActivityNetAmt != this.dNET) {
          this.msgErrorNET = true;
          return false;
        }
      }
      this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
        element.MontantTVA = this.conversionCommaToDot(this.dTVA);
        element.MontantNet = this.conversionCommaToDot(this.dNET);
        element.CodePourcentTot = 0;
        element.Statut = "ACTIVE";
      });
      this.ClearPercntageFields();

      this.PrepareFormRootData();
      this.PrepareHeaderData();
      this.PrepareDeclarationData();
      this.DeleteUnavailableActivity();
      if (this.FormsData !== null) {
        this.FormsData.forEach(element => {
          if (element.Genre == "O" && element.NoDeclaration == this.selectedDeclarationNo) {
            element.MontantTVA = this.conversionCommaToDot(this.dTVA);
            element.MontantNet = this.conversionCommaToDot(this.dNET);
            element.MontantBrut = this.conversionCommaToDot(this.Total);
            element.CodePourcentTot = 0;
            element.CodeMontantBrut = "OFACTTTOT";
            element.CodeMontantNet = "OFACTTNET";
            element.CodeMontantTVA = "OFACTTTVA";
            element.LastModifiedDate = formatDate(this.today, 'dd/MM/yyyy', 'en-US', '+0100');
            element.PeriodeDebut = element.PeriodeDebut == null ? "" : (element.PeriodeDebut.length == 10 ? element.PeriodeDebut : this.customDateFormat(element.PeriodeDebut));
            element.PeriodeFin = element.PeriodeFin == null ? "" : (element.PeriodeFin.length == 10 ? element.PeriodeFin : this.customDateFormat(element.PeriodeFin));
            element.Statut = "ACTIVE";
            element.Exercice = parseInt(sessionStorage.getItem("Year"));
            element.Comment = this.remarks;
            var activite = [];
            this.declaration4Data.dataXML.XMLFile.Declaration.forEach(item => {
              if (item.Genre == 'O' && item.NoDeclaration == this.selectedDeclarationNo) {
                item.Activite.forEach(e => {
                  if(activite.filter(u => u.CodeActivite === e.CodeActivite).length == 0)
                  {
                    activite.push(e);
                  }
                });
              }
            });
            element.Activite = activite;
          }
          else {
            this.declaration4Data.dataXML.XMLFile.Declaration.push(element);
          }
        });
      }

      this.declaration4Data.dataXML.XMLFile.Declaration = this.FormsData;
      this.SavedData = this.declaration4Data;
      var JsonForm4SaveDeclaration = JSON.stringify(this.SavedData);
      this.Declaration4Data = JSON.parse(JsonForm4SaveDeclaration);

      this.service.SaveDeclaration1(this.Declaration4Data).subscribe(
        (data) => { //Save NET TVA
          if (data == 'Failed') {
            this.msgErrorNotSaved = true;
            sessionStorage.setItem('isForm4Saved', 'false');
          }
          else {
            sessionStorage.setItem("FormsData", JSON.stringify(this.FormsData));
            sessionStorage.setItem("AllDeclarationData", JsonForm4SaveDeclaration);
            sessionStorage.setItem("SavedDeclaration1CachedData", JsonForm4SaveDeclaration);
            sessionStorage.setItem('isForm4Saved', 'true');
            sessionStorage.setItem('form4SubmittedDate', formatDate(this.today, 'dd/MM/yyyy ', 'en-US', '+0100'));
            this.gotoDashboard();
          }
        },
        (err) => {
          this.msgErrorNotSaved = true;
        });
    }

  }

  ngOnDestroy(): void {
    sessionStorage.removeItem("selectedFormData");
    this.declaration4Data.dataXML.XMLFile.Declaration =
      [
        {
          Comment: "",
          contrat: [],
          Exercice: 0,
          PeriodeDebut: '',
          PeriodeFin: '',
          NoDeclaration: 0,
          NoProgressif: 0,
          Genre: "",
          noIntervenantDestinataire: 0,
          NomDestinataire: "",
          PrenomDestinataire: "",
          RoleDestinataire: "",
          Statut: "",
          Libelle: "",
          CodeMontantBrut: "",
          MontantBrut: 0,
          CodeMontantNet: '',
          MontantNet: 0,
          CodeMontantTVA: '',
          MontantTVA: 0,
          TVAApplicable: 1,
          CodeActivite: "",
          Activite: [
            {
              TVAApplicable: 0,
              CodeActivite: "",
              Libelle: "",
              CodeMontantBrut: "",
              CodeMontantNet: "",
              CodeMontantTVA: "",
              MontantNet: 0,
              MontantTVA: 0,
              MontantBrut: 0,
              CodeRepartition: "",
              Pourcent: 0
            },
            {
              TVAApplicable: 0,
              CodeActivite: "",
              Libelle: "",
              CodeMontantBrut: "",
              CodeMontantNet: "",
              CodeMontantTVA: "",
              MontantNet: 0,
              MontantTVA: 0,
              MontantBrut: 0,
              CodeRepartition: "",
              Pourcent: 0
            },
            {
              TVAApplicable: 0,
              CodeActivite: "",
              Libelle: "",
              CodeMontantBrut: "",
              CodeMontantNet: "",
              CodeMontantTVA: "",
              MontantNet: 0,
              MontantTVA: 0,
              MontantBrut: 0,
              CodeRepartition: "",
              Pourcent: 0
            },
            {
              TVAApplicable: 0,
              CodeActivite: "",
              Libelle: "",
              CodeMontantBrut: "",
              CodeMontantNet: "",
              CodeMontantTVA: "",
              MontantNet: 0,
              MontantTVA: 0,
              MontantBrut: 0,
              CodeRepartition: "",
              Pourcent: 0
            },
            {
              TVAApplicable: 0,
              CodeActivite: "",
              Libelle: "",
              CodeMontantBrut: "",
              CodeMontantNet: "",
              CodeMontantTVA: "",
              MontantNet: 0,
              MontantTVA: 0,
              MontantBrut: 0,
              CodeRepartition: "",
              Pourcent: 0
            },
          ],
          LastModifiedDate: "",
          CodePourcentTot: 0,
          independant: [

          ]
        }
      ];
    this.activitiesCollection = [];
  }

  gotoDashboard() {
    this._router.navigate(['/dashboard']);
  }
  ClearMsgFields() {
    this.msgErrorPercent = false; // if percentages does not 100%
    this.msgErrorNET = false; // if the Net ammount is not equal to actvities net amount
    this.msgErrorNotSaved = false;
    this.msgErrorFieldMissing = false;//mandatory field missing
    this.msgMaxPercentageError = false;
  }

  PrepareFormRootData() {
    this.declaration4Data.FormType = 'DECL_ON_2020';
    this.declaration4Data.FormSubType = 'FORM';
    this.declaration4Data.ContractNummer = '';
    this.declaration4Data.AccountNumber = sessionStorage.getItem('ClientNo');
    this.declaration4Data.User = 0; //yet to get from -  RetrieveDeclarationParClient
  }
  PrepareHeaderData() {
    this.declaration4Data.dataXML.XMLFile.Header.NoClient = parseInt(sessionStorage.getItem('ClientNo'));
    this.declaration4Data.dataXML.XMLFile.Header.Email = sessionStorage.getItem('NewEmail') != null ? sessionStorage.getItem('NewEmail') : sessionStorage.getItem('Email');
    this.declaration4Data.dataXML.XMLFile.Header.CodePostal = this.clientsData.CodePostal;
    this.declaration4Data.dataXML.XMLFile.Header.LibellePays = this.clientsData.LibellePays;
    this.declaration4Data.dataXML.XMLFile.Header.Localite = this.clientsData.Localite;
    this.declaration4Data.dataXML.XMLFile.Header.Rue = this.clientsData.Rue;
    this.declaration4Data.dataXML.XMLFile.Header.NoRue = this.clientsData.NoRue;
    this.declaration4Data.dataXML.XMLFile.Header.QualCiv = this.clientsData.QualCiv;
    this.declaration4Data.dataXML.XMLFile.Header.RegimeLinguistique = sessionStorage.getItem("currentlang") === 'FR' ? 1 : 2;
    this.declaration4Data.dataXML.XMLFile.Header.Nom = this.clientsData.Nom;
    this.declaration4Data.dataXML.XMLFile.Header.Prenom = this.clientsData.Prenom;
  }
  PrepareDeclarationData() {
    this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
      if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo) {
        element.Comment = this.Form4.get("remarks").value;
        element.Genre = 'O';
        element.Exercice = parseInt(sessionStorage.getItem("Year"));
        element.noIntervenantDestinataire = this.form4Data.NoIntervenantDestinataire;
        element.RoleDestinataire = this.form4Data.RoleDestinataire;
        element.NoDeclaration = this.form4Data.NoDeclaration;
        element.NomDestinataire = this.form4Data.NomDestinataire;
        element.NoProgressif = this.form4Data.NoProgressif;

        element.RoleDestinataire = this.form4Data.RoleDestinataire;
        element.CodeMontantBrut = 'OFACTTTOT';
        element.CodeMontantNet = 'OFACTTNET';
        element.CodeMontantTVA = 'OFACTTTVA'
        element.MontantBrut = this.conversionCommaToDot(this.Total);
      }
    });
  }
  customDateFormat(date) {
    if (date !== '' && date !== null) {
      if (date.length == 19) {
        var year = date.substring(0, 4);
        var month = date.substring(7, 5);
        var day = date.substring(10, 8);
        return [day, month, year].join('/');
      } else if (date.length == 8) {
        var year = date.substring(0, 4);
        var month = date.substring(6, 4);
        var day = date.slice(date.length - 2);
        return [day, month, year].join('/');
      } else if (date.length == 10) {
        var year = date.substring(0, 4);
        var month = date.substring(7, 5);
        var day = date.slice(date.length - 2);
        return [day, month, year].join('/');
      } else {
        return null;
      }
    }
  }
  DisablePercentageControlls() {
    this.DisableEnableControl('activity1Percent', false);
    this.DisableEnableControl('activity2Percent', false);
    this.DisableEnableControl('activity3Percent', false);
    this.DisableEnableControl('activity4Percent', false);
    this.DisableEnableControl('activity5Percent', false);
  }

  EnablePercentageControlls() {
    this.DisableEnableControl('activity1Percent', true);
    this.DisableEnableControl('activity2Percent', true);
    this.DisableEnableControl('activity3Percent', true);
    this.DisableEnableControl('activity4Percent', true);
    this.DisableEnableControl('activity5Percent', true);
  }

  DisableNetTVAControlls() {
    this.DisableEnableControl('activity1Net', false);
    this.DisableEnableControl('activity1Tva', false);
    this.DisableEnableControl('activity2Net', false);
    this.DisableEnableControl('activity2Tva', false);
    this.DisableEnableControl('activity3Net', false);
    this.DisableEnableControl('activity3Tva', false);
    this.DisableEnableControl('activity4Net', false);
    this.DisableEnableControl('activity4Tva', false);
    this.DisableEnableControl('activity5Net', false);
    this.DisableEnableControl('activity5Tva', false);
  }

  ClearNETTVAFields() {
    if (this.isActivity1Present) {
      this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
        if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo) {
          element.Activite[0].MontantNet = 0;
          element.Activite[0].MontantTVA = 0;
          element.Activite[0].MontantBrut = 0;
        }
      });
    }
    if (this.isActivity2Present) {
      this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
        if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo) {
          element.Activite[1].MontantNet = 0;
          element.Activite[1].MontantTVA = 0;
          element.Activite[1].MontantBrut = 0;
        }
      });
    }
    if (this.isActivity3Present) {
      this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
        if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo) {
          element.Activite[2].MontantNet = 0;
          element.Activite[2].MontantTVA = 0;
          element.Activite[2].MontantBrut = 0;
        }
      });
    }
    if (this.isActivity4Present) {
      this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
        if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo) {
          element.Activite[3].MontantNet = 0;
          element.Activite[3].MontantTVA = 0;
          element.Activite[3].MontantBrut = 0;
        }
      });
    }
    if (this.isActivity5Present) {
      this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
        if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo) {
          element.Activite[4].MontantNet = 0;
          element.Activite[4].MontantTVA = 0;
          element.Activite[4].MontantBrut = 0;
        }
      });
    }
  }

  ClearPercntageFields() {
    if (this.isActivity1Present) {
      this.declaration4Data.dataXML.XMLFile.Declaration[0].Activite[0].Pourcent = 0;
    }
    if (this.isActivity2Present) {
      this.declaration4Data.dataXML.XMLFile.Declaration[0].Activite[1].Pourcent = 0;
    }
    if (this.isActivity3Present) {
      this.declaration4Data.dataXML.XMLFile.Declaration[0].Activite[2].Pourcent = 0;
    }
    if (this.isActivity4Present) {
      this.declaration4Data.dataXML.XMLFile.Declaration[0].Activite[3].Pourcent = 0;
    }
    if (this.isActivity5Present) {
      this.declaration4Data.dataXML.XMLFile.Declaration[0].Activite[4].Pourcent = 0;
    }
  }
  EnabledNetTVAControlls() {
    this.DisableEnableControl('activity1Net', true);
    this.DisableActivity1TVA();
    this.DisableEnableControl('activity2Net', true);
    this.DisableActivity2TVA();
    this.DisableEnableControl('activity3Net', true);
    this.DisableActivity3TVA();
    this.DisableEnableControl('activity4Net', true);
    this.DisableActivity4TVA();
    this.DisableEnableControl('activity5Net', true);
    this.DisableActivity5TVA();
  }
  TVAThreasholdCheck(netValue: number, tvaValue: number): boolean {
    if (tvaValue > 0) {
      var total = (netValue / 100) * 30;
      if (total < tvaValue) {
        return true;
      }
      else {
        return false;
      }
    }
  }
  DeleteUnavailableActivity() {
    if (!this.isActivity2Present)
      this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
        if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo) {
          element.Activite.splice(1);
        }
      });
    if (!this.isActivity3Present)
      this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
        if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo) {
          element.Activite.splice(2);
        }
      });
    if (!this.isActivity4Present)
      this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
        if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo) {
          element.Activite.splice(3);
        }
      });
    if (!this.isActivity5Present)
      this.declaration4Data.dataXML.XMLFile.Declaration.forEach(element => {
        if (element.Genre == 'O' && element.NoDeclaration == this.selectedDeclarationNo) {
          element.Activite.splice(4);
        }
      });
  }


  DisableActivity1TVA() {
    if (this.activity1Model.TVAApplicable) {
      this.DisableEnableControl('activity1Tva', true);
    }
    else {
      this.DisableEnableControl('activity1Tva', false);
    }
  }
  DisableActivity2TVA() {
    if (this.activity2Model.TVAApplicable) {
      this.DisableEnableControl('activity2Tva', true);
    }
    else {
      this.DisableEnableControl('activity2Tva', false);
    }
  }
  DisableActivity3TVA() {
    if (this.activity3Model.TVAApplicable) {
      this.DisableEnableControl('activity3Tva', true);
    }
    else {
      this.DisableEnableControl('activity3Tva', false);
    }
  }
  DisableActivity4TVA() {
    if (this.activity4Model.TVAApplicable) {
      this.DisableEnableControl('activity4Tva', true);
    }
    else {
      this.DisableEnableControl('activity4Tva', false);
    }
  }
  DisableActivity5TVA() {
    if (this.activity5Model.TVAApplicable) {
      this.DisableEnableControl('activity5Tva', true);
    }
    else {
      this.DisableEnableControl('activity5Tva', false);
    }
  }
}


